import BuyCard from "../common/buy-card";
import ratingImg from "../../assets/img/rating.png";
import ratingImgWebp from "../../assets/img/rating.webp";
import firstProductImg from "../../assets/img/product-ov-1.png";
import firstProductImgWebp from "../../assets/img/product-ov-1.webp";
import secondProductImg from "../../assets/img/product-ov-6.png";
import secondProductImgWebp from "../../assets/img/product-ov-6.webp";
import thirdProductImg from "../../assets/img/product-ov-3.png";
import thirdProductImgWebp from "../../assets/img/product-ov-3.webp";

const Buy = () => {
    return (
        <section id="buy" >
            <div className="container-fluid text-center pt-5 pb-4">
                <div className="row justify-content-center align-items-center">
                    <div className="col-lg-3 col-11 mb-lg-1 mb-3">
                        <BuyCard
                            title="Try One"
                            subtitle="30 Day Supply"
                            imgSrc={firstProductImg}
                            imgSrcWebp={firstProductImgWebp}
                            bottlePrice={69}
                            savings={110}
                            hasGift={false}
                            total={179}
                            totalWithDiscount={69}
                            isFreeShipping={true}
                            buyLink="https://buygoods.com/secure/upsell/?account_id=11273&product_codename=opt1&redirect=aHR0cHM6Ly9idXlnb29kcy5jb20vdGhhbmt5b3U/YWNjb3VudF9pZD0xMTI3Mw=="
                            gtmLabel="Buy 1 OptiVista"
                            gtmProduct="opt1"
                            showBorder={false}
                        />
                    </div>
                    <div className="col-lg-3 col-11 mb-lg-1 mb-3">
                        <BuyCard
                            title="Most Popular"
                            subtitle="90 Day Supply"
                            imgSrc={thirdProductImg}
                            imgSrcWebp={thirdProductImgWebp}
                            bottlePrice={49}
                            savings={375}
                            hasGift={false}
                            total={522}
                            totalWithDiscount={147}
                            isFreeShipping={true}
                            buyLink="https://buygoods.com/secure/upsell/?account_id=11273&product_codename=opt3&redirect=aHR0cHM6Ly9idXlnb29kcy5jb20vdGhhbmt5b3U/YWNjb3VudF9pZD0xMTI3Mw=="
                            gtmLabel="Buy 3 OptiVista"
                            gtmProduct="opt3"
                            showBorder={true}
                        />
                    </div>
                    <div className="col-lg-3 col-11 mb-lg-1 mb-3">
                        <BuyCard
                            title="Best Value"
                            subtitle="180 Day Supply"
                            imgSrc={secondProductImg}
                            imgSrcWebp={secondProductImgWebp}
                            bottlePrice={29}
                            savings={900}
                            hasGift={false}
                            total={1074}
                            totalWithDiscount={174}
                            isFreeShipping={true}
                            buyLink="https://buygoods.com/secure/upsell/?account_id=11273&product_codename=opt6&redirect=aHR0cHM6Ly9idXlnb29kcy5jb20vdGhhbmt5b3U/YWNjb3VudF9pZD0xMTI3Mw=="
                            gtmLabel="Buy 6 OptiVista"
                            gtmProduct="opt6"
                            showBorder={false}
                        />
                    </div>
                </div>
                <div className="row justify-content-center align-items-center mt-2">
                    <div className="col-11">
                        <span className="small me-2">Our customers say <b>4.98/5</b></span>
                        <picture>
                            <source srcSet={ratingImgWebp} type="image/webp" />
                            <img className="img-fluid gg-buy-img-rating mb-1" alt="rating" src={ratingImg} loading="lazy" />
                        </picture>
                        <span className="small ms-2"> Based on 2000+ reviews</span>
                    </div>
                </div>
                <div className="row justify-content-center align-baseline mt-4">
                    <div className="col-11">
                        <a href="#testimonials" className="text-black small pe-2 gtm-nav-btn" data-gtm-label="Optivista Upsell 6 - Buy Section - View Reviews">View Reviews</a>
                    </div>
                </div>
            </div>
        </section>
    )
};

export default Buy;